/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePackFeeVo
 */
export interface UpdatePackFeeVo {
    /**
     * 商品单独包装费用
     * @type {number}
     * @memberof UpdatePackFeeVo
     */
    individuallyPackagedFee?: number;
    /**
     * 商品合包包装费用
     * @type {number}
     * @memberof UpdatePackFeeVo
     */
    combinedPackagedFee?: number;
    /**
     * 贴条码费用
     * @type {number}
     * @memberof UpdatePackFeeVo
     */
    barcodeFee?: number;
    /**
     * 缝产地标费用
     * @type {number}
     * @memberof UpdatePackFeeVo
     */
    originMarkFee?: number;
    /**
     * 使用opp袋费用
     * @type {number}
     * @memberof UpdatePackFeeVo
     */
    oppFee?: number;
    /**
     * 使用快递袋费用
     * @type {number}
     * @memberof UpdatePackFeeVo
     */
    courierBagFee?: number;
}

/**
 * Check if a given object implements the UpdatePackFeeVo interface.
 */
export function instanceOfUpdatePackFeeVo(value: object): value is UpdatePackFeeVo {
    return true;
}

export function UpdatePackFeeVoFromJSON(json: any): UpdatePackFeeVo {
    return UpdatePackFeeVoFromJSONTyped(json, false);
}

export function UpdatePackFeeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePackFeeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'individuallyPackagedFee': json['individuallyPackagedFee'] == null ? undefined : json['individuallyPackagedFee'],
        'combinedPackagedFee': json['combinedPackagedFee'] == null ? undefined : json['combinedPackagedFee'],
        'barcodeFee': json['barcodeFee'] == null ? undefined : json['barcodeFee'],
        'originMarkFee': json['originMarkFee'] == null ? undefined : json['originMarkFee'],
        'oppFee': json['oppFee'] == null ? undefined : json['oppFee'],
        'courierBagFee': json['courierBagFee'] == null ? undefined : json['courierBagFee'],
    };
}

export function UpdatePackFeeVoToJSON(json: any): UpdatePackFeeVo {
    return UpdatePackFeeVoToJSONTyped(json, false);
}

export function UpdatePackFeeVoToJSONTyped(value?: UpdatePackFeeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'individuallyPackagedFee': value['individuallyPackagedFee'],
        'combinedPackagedFee': value['combinedPackagedFee'],
        'barcodeFee': value['barcodeFee'],
        'originMarkFee': value['originMarkFee'],
        'oppFee': value['oppFee'],
        'courierBagFee': value['courierBagFee'],
    };
}

